import React from 'react';

import {skipToken} from '@reduxjs/toolkit/query';

import {useFolderByHashid} from 'app/folders/api';
import {CreateFolderForm} from 'app/folders/components/dashboards/CreateFolder';
import {gt} from 'app/utils/i18n';

import {AddItemFormBox} from './AddItemFormBox';

type Props = {folderHashid?: string; finalCallback: () => void};
export const AddFolderToFolder = ({folderHashid, finalCallback}: Props) => {
  const {currentData: selectedFolder} = useFolderByHashid(
    folderHashid != null ? folderHashid : skipToken
  );

  return (
    <AddItemFormBox label={gt('Add new folder')}>
      <CreateFolderForm
        autoFocus={true}
        onCreate={finalCallback}
        onCancel={finalCallback}
        parent={selectedFolder}
        teams={selectedFolder?.teams || []}
      />
    </AddItemFormBox>
  );
};
